import {
  apiV1Endpoint,
  dashboardApiV1Endpoint,
} from "../../../../../api/v1/endpoints";
import axios from "../../../../../utils/axiosInceptor";

export const getPaidMetrics = (body) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/paid-metrics`, body)
    .then((res) => res.data);
export const getUnPaidMetrics = (body) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/unpaid-metrics`, body)
    .then((res) => res.data);
export const getPaidByAge = (body) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/bookingbyage-metrics`, body)
    .then((res) => res.data);
export const getRenewalTrends = (body: any) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/renewals-timeline`, body)
    .then((res) => res.data);
export const getRenewalAwaitingDecisions = (body: any) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/renewals-summary`, body)
    .then((res) => res.data);
export const bookingFunnel = (body: any) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/bookingfunnel`, body)
    .then((res) => res.data);
export const bookingperMonth = (body: any) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/bookingPerMonth`, body)
    .then((res) => res.data);
export const bookingOverView = (queryString: any) =>
  axios
    .get(`${dashboardApiV1Endpoint}/dashboard/get-total-bookings${queryString}`)
    .then((res) => res.data);
export const bookingWidgets = (body: any) =>
  axios
    .post(`${apiV1Endpoint}/dashboard/widgets`, body)
    .then((res) => res.data);
export const leaderBoard = (body: any) =>
  axios
    .post(`${dashboardApiV1Endpoint}/dashboard/bookingLeaderboard`, body)
    .then((res) => res.data);
